import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ErrorsInterface } from '../errors/errors-interface';
import { Observable } from 'rxjs';
import { PartnerUser } from './definitions/partner-user-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface PartnerUserCreateResponse {
  partner: {
    create: {
      output: PartnerUser;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class PartnerUserCreateService {
  constructor(private apollo: Apollo) {}

  create(
    partnerId: string,
    name: string,
    email: string,
    username: string,
    notificationMissingDocuments: boolean,
    notificationTaskCompleted: boolean,
    mutation: DocumentNode
  ): Observable<FetchResult<any>> {
    return this.apollo.mutate<PartnerUserCreateResponse>({
      mutation: mutation,
      variables: {
        partnerId: partnerId,
        name: name,
        email: email,
        username: username,
        notificationMissingDocuments: notificationMissingDocuments,
        notificationTaskCompleted: notificationTaskCompleted,
      },
    });
  }
}
